import { render, staticRenderFns } from "./BeneficiaryInfo.vue?vue&type=template&id=4a8bc95a"
import script from "./BeneficiaryInfo.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports